import styled from 'styled-components'
import {ReactComponent as SearchIcon} from '../../assets/icons/search.svg'
import {ReactComponent as User} from '../../assets/icons/user.svg';
import {ReactComponent as Cart} from '../../assets/icons/cart.svg'


export const Container = styled.div `
box-sizing:border-box;
padding: 16px 200px;


`
Container.Dropdown = styled.div`
display: flex;
flex-wrap: wrap;
width: 230px;
font-family: Poppins;
font-style: normal;
font-weight: bold;
font-size: 15px;
line-height: 22px;
color: #151515;

`

export const NavWrapper = styled.div `
display: flex;
justify-content:space-between;
align-items: center;
margin-bottom:10px;
padding:10px 0 0;
margin:${({search})=> search? '40px 0 36px 0' : '0'};
border-bottom:${({top})=> top && '1px solid lightGray'};
`
export const Wrapper = styled.div `
display: flex;
position: relative;

`

export const Link = styled.a `
margin:0 0 20px 38px;
font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 15px;
line-height: 16px;

color: ${({defaultColor})=> defaultColor? '#151515': '#6A983C'};
cursor: pointer;
:first-child{
  margin-left:0;
}
`

export const SearchContainer = styled.div`
position: relative;
display: flex;
align-items: center;
border: 1px solid #D1D1D1;
border-radius: 12px;
padding:6px;
background: #F9F9F9;
`

export const SelectOption = styled.select`
  height: 35px;
  font-size: 14px;
  border: none;
  outline:none;
  cursor: pointer;
  font-weight:800;
  background: #F9F9F9;
    padding-left:16px;
    padding-right:12px;
    margin-right:28px;
    width:200px;
    
 
`
export const Header = styled.img`
width:177px;
height:18px;
cursor: pointer;

`
export const Search = styled.input`
padding: 0 40px 0 20px;
width:400px;
height: 36px ;
background: #F9F9F9;
border:none;
outline:none;
border-left: 1px solid #D1D1D1;
font-size:14px;
color:gray;
`
 
//*Icon */ 

export const Icon = styled.div`
`
Icon.SearchIcon = styled(SearchIcon)`
position: absolute;
top:12px;
right:10px;
width:15px;
height:14px;
padding:0;
margin:0;
cursor: pointer;
`
 
Icon.UserIcon = styled(User)`
width:19px;
height:19px;
margin-right:40px;
cursor: pointer;
`
export const Update = styled.div`
text-align: center;
position: absolute;
cursor: pointer;
top:10px;
right:8px;
width:15px;
height:15px;
color:white;
background: #E6704B;
box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
border-radius: 12px;
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 15px;
`
Icon.CartIcon = styled(Cart)`
width:19px;
height:19px;
cursor: pointer;
font-style:bold;
`